import { VTTContent } from '@vidstack/react';
import { Transcript } from './types';

export const transcriptToVTT = (transcript: Transcript): VTTContent => {
  return {
    cues: transcript.segments.map((segment) => ({
      startTime: segment.startTime,
      endTime: segment.endTime,
      text: segment.text,
    })),
    regions: [],
  };
};
